// extracted by mini-css-extract-plugin
module.exports = {"adminPreview":"AdminPreview_adminPreview__2KdQA"};